import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rateSource", "manualRateField"]

  connect() {
    this.toggleManualRate()
  }

  toggleManualRate() {
    const isManual = this.rateSourceTarget.value === "manual"
    
    if (this.hasManualRateFieldTarget) {
      if (isManual) {
        this.manualRateFieldTarget.style.display = "block"
      } else {
        this.manualRateFieldTarget.style.display = "none"
      }
    }
  }
}
